import {ClsPeticionPresupuestos} from './cls-pr-generico';
import {ClsErrores} from '../cls-errores';
import {ClsGuardarMatriz, ClsMatriz} from '../cls-matriz';

export class ClsPeticionMatrices extends ClsPeticionPresupuestos {
  IdOrganizacion: bigint;
  IdCodigoMatriz: bigint;
}

export class ClsRespuestaMatrices {
  Matrices: ClsMatriz[];
  Errores: ClsErrores;
}

export class ClsPeticionMatrizRegistraActualiza extends  ClsPeticionPresupuestos {
  Catalogo: ClsMatriz[];
}

export class ClsPeticionGuardarMatriz extends ClsPeticionPresupuestos {
  IdPresupuestoMaestro: bigint;
  Matriz: ClsGuardarMatriz[];
}

export class ClsRespuestaTodasLasMatrices {
  LsCatalogo: ClsMatriz[];
  Errores: ClsErrores;
}

export class ClsPeticionRegistraActualizaPendAnalisar extends ClsPeticionPresupuestos {
  IdCodigoMatriz: bigint;
  DescripcionLarga: string;
  PendienteAnalizar: boolean;
  ObservacionPendiente: string;
  CostoMoneda1: number;
  CostoMoneda2: number;
}

export class ClsMatricesStorageZip {
  Matrices: string;
  Errores: ClsErrores;
}
